$.nette.ext('recaptchaAjax', {
	// hacky manual way of handling recaptcha with ajax request
	// basically we just use the 'before' extension and do the callback manually
	before: function(payload, status, nette) {
		const { ui, e } = status.nette;
		if (!status.nette || !status.nette.form) return true;
		const form = status.nette.form[0];
		const recaptchaResponse = $(form).find('.g-recaptcha-response');
		// skip if no recaptcha
		if (recaptchaResponse.length === 0) return true;

		if (!recaptchaResponse.val()) {
			// first pass
			const listener = Nette.recaptchaSubmitListenerFactory(form);
			listener(e, () => {
				const settings = {
					url: status.url,
					method: status.POST,
					data: status.data
				}
				nette.ajax(settings, ui, e);
			});
			return false;
		} else {
			// second pass, the recaptcha response is filled
			return true;
		}
	}
});
